<template>
  <div>
    <div v-if="loading">
      <p>Cargando..</p>
    </div>
    <div class="mb-8 flex justify-start max-w-3xl">
      <h1 class="font-bold text-3xl">
        <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('contacts')">Paciente</inertia-link>
        <span class="text-indigo-400 font-medium">/</span>
        Crear
      </h1>
     
    </div>
    <div class="flex flex-wrap">
    <div class="w-full">
      <ul class="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row">
        <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
          <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="toggleTabs(1)" v-bind:class="{'text-amber-600 bg-white': openTab !== 1, 'text-black bg-amber-600': openTab === 1}">
            Datos personales
          </a>
        </li>
      </ul>
      <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
        
        <div class="px-4 py-5 flex-auto">
          <div class="tab-content tab-space">
            <div v-bind:class="{'hidden': openTab !== 1, 'block': openTab === 1}">
              <form @submit.prevent="store">
              <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                <select-input v-model="form.tipo_identificacion" :req="form.tipo_identificacion" :error="form.errors.tipo_identificacion" class="pr-6 pb-8 w-full lg:w-2/6" label="Tipo de Identificación" required>
                <option>Cédula</option>
                <option>Pasaporte</option>
                <option>RUC</option>
              </select-input>
             
             
          <text-input v-model="form.ruc" :error="form.errors.ruc" :req="form.ruc" class="pb-8 pr-6 w-full lg:w-1/6" label="Identificación" required/>
          <select-input v-model="form.tipo_sangre" :error="form.errors.tipo_sangre" :req="form.tipo_sangre" class="pr-6 pb-8 w-full lg:w-2/6" label="Tipo de Sangre" required>
            <option>No Conoce</option>
            <option>A positivo (A +)</option>
            <option>A negativo (A-)</option>
            <option>B positivo (B +)</option>
             <option>B negativo (B-)</option>
             <option>AB positivo (AB+)</option>
             <option>AB negativo (AB-)</option>
             <option>O positivo (O+)</option>
              <option>O negativo (O-)</option>
          </select-input>
          <select-input v-model="form.estado_civil" :error="form.errors.estado_civil" :req="form.estado_civil" class="pr-6 pb-8 w-full lg:w-1/6" label="Estado Civil" required>
            <option>Casado/a</option>
            <option>Soltero/a</option>
            <option>Divorciado/a</option>
            <option>Unión Libre</option>
            <option>Viudo/a</option>
          </select-input>
         
          <text-input v-model="form.nombres" :error="form.errors.nombres" :req="form.nombres" class="pb-8 pr-6 w-full lg:w-2/6" label="Nombres" required/>
          <text-input v-model="form.apellidos" :error="form.errors.apellidos" :req="form.apellidos" class="pb-8 pr-6 w-full lg:w-2/6" label="Apellidos" />
          <select-input v-model="form.sexo" :error="form.errors.sexo" :req="form.sexo" class="pr-6 pb-8 w-full lg:w-2/6" label="Sexo" required>
            <option>Masculino</option>
            <option>Femenino</option>
          </select-input>
          <div class="container pb-8 pr-6 w-full lg:w-4/6">
            <label class="form-label" >Profesión:</label>
            <v-select v-model="form.profesions" :options="profesiones" label="descripcion"></v-select>
        </div>
        <div class="container pb-8 pr-6 w-full lg:w-1/6">
            <label class="form-label" >Fecha Nacimiento:</label>
          <date-picker v-model="form.fecha_nacimiento" lang="es" ></date-picker>
          </div>
          <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-2/6" label="Email" />
          <text-input v-model="form.telefono" :error="form.errors.telefono" class="pb-8 pr-6 w-full lg:w-2/6" label="Teléfono" />
          <file-input v-model="form.foto_url" :error="form.errors.foto_url" class="pb-8 pr-6 w-full lg:w-2/6" type="file" accept="image/*" label="Foto" />
        <!--  <img v-bind:src="photo" width="90" height="90" alt="">-->
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Crear Paciente</loading-button>
        </div>
      </form>
            </div>
            <div v-bind:class="{'hidden': openTab !== 2, 'block': openTab === 2}">
            </div>
            <div v-bind:class="{'hidden': openTab !== 3, 'block': openTab === 3}">
            </div>
          </div>
        </div>
       
      </div>
    </div>
  </div>
  <preloader />
  </div>
  
</template>

<script>
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';


export default {
  metaInfo: { title: 'Crear Paciente' },
  components: {
    FileInput,
    LoadingButton,
    SelectInput,
    TextInput,
    vSelect,
    DatePicker,
  },
  layout: Layout,
  props: {
    users: Array,
  },
  remember: 'form',
  data() {
    return {
      openTab: 1,
      loading: true,
      profesiones: this.users,
      form: this.$inertia.form({
        nombres: '',
        apellidos: '',
        foto_url: null,
        profesions: null,
        tipo_identificacion: null,
        ruc: null,
        fecha_nacimiento:null,
        sexo: null,
        direccion: null,
        email: null,
        telefono: null,
        tipo_sangre: null,
        nombres_contacto: null,
        telefono_contacto: null,
        direcion_contacto: null,
        parentesco_contacto: null,
        estado_civil: null,
      }),
    }
  },
  async mounted(){
    await this.users
    this.loading=false
  },
  methods: {
    toggleTabs: function(tabNumber){
      this.openTab = tabNumber
    },
    store() {
      
      this.form.post('/contacts')
    },
   
  },
}
</script>